import { render } from "./MainContentLayout.vue?vue&type=template&id=32a75a68"
import script from "./MainContentLayout.vue?vue&type=script&lang=js"
export * from "./MainContentLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/sites/fcs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/member/views/layouts/MainContentLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32a75a68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32a75a68', __exports__)) {
    console.log('reload')
    api.reload('32a75a68', __exports__)
  }
  
  module.hot.accept("./MainContentLayout.vue?vue&type=template&id=32a75a68", () => {
    console.log('re-render')
    api.rerender('32a75a68', render)
  })

}


export default __exports__